import axios from 'axios';

const infrastructureApi = axios.create({
    baseURL: "/api/auth",
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

export default infrastructureApi;